import * as React from 'react';
import { useState } from 'react';
import { ImageInput } from 'react-admin';
import { useForm } from 'react-final-form';
import { apiUrl, httpClient } from '../providers/data.provider';
import { MediaField } from './MediaField';

const PreviewImage = ({ file, record, source }: any) => {
	console.log(file);

	if (typeof (record) == 'string') {
		record = {
			[source]: record
		};
	}

	return <MediaField isVideo={typeof (record) != 'string' && file?.path.endsWith('mp4')} record={record}
	                   source={source}/>;
};

export const MediaInput = ({ record, source, ...props }: any) => {
	const form = useForm();
	const [file, setFile] = useState<File>();

	const onFileChange = async (fileToUpload: any) => {
		if (fileToUpload) {
			setFile(fileToUpload);

			const formData = new FormData();

			formData.append('fileToUpload', fileToUpload);

			const { json } = await httpClient(`${apiUrl}/files/upload`, {
				method: 'POST',

				body: formData
			});

			form.change(source, json.data);
		}
	};

	return <ImageInput {...props} source={source}
	                   onChange={onFileChange}
	>
		<PreviewImage file={file} source="src"/>
	</ImageInput>;
};
